import { Icon } from 'assets/index'
import { ButtonNext } from './style'

interface IButtonNextProps {
  isBack?: boolean
  isAdvance?: boolean
  advancePage?: () => void
  backPage?: () => void
}

export default function BtnNext(props: IButtonNextProps) {
  const { isBack, isAdvance, advancePage, backPage } = props
  return (
    <ButtonNext allowNextPage isAdvance={isAdvance} isBack={isBack}>
      {!isBack ? null : (
        <div className="btn-circle">
          <img
            className="btn-next-icon"
            onClick={backPage}
            src={Icon('chevron_left.svg')}
            alt="back button"
          />
        </div>
      )}
      {isBack ? 'VOLTAR' : 'AVANÇAR'}
      {!isAdvance ? null : (
        <button className="btn-circle" type={'submit'} onClick={advancePage}>
          <img
            className="btn-next-icon"
            src={Icon('chevron_right.svg')}
            alt="advance button"
          />
        </button>
      )}
    </ButtonNext>
  )
}
